<div class="header animated fadeIn">
  <h1 class="header__text">
    {{ "dashboard.dashboardGreeting" | translate }} {{ userDetails.firstName }}
  </h1>
  <span class="sub-head mb-3">
    {{ "dashboard.dashboardDescription" | translate }}
  </span>
</div>
<div class="container-fluid">
  <div class="row px-3">
    <div class="col-lg-4 col-md-12 mb-3">
      <div class="bg-white p-3 rounded shadow-sm card_metric h-100">
        <div class="heading_icon">
          <img
            src="../../../../../assets/images/device_icon.svg"
            alt="terminals"
          />
          <span>Devices</span>
        </div>
        <div class="metric">
          <span>{{ dashboardData?.totalConfiguredDevices }}</span>
        </div>
        <div class="small_metric">
          <span>{{ totalOemCount }}</span>
          <span>Terminals</span>
        </div>
      </div>
    </div>

    <div class="col-lg-4 col-md-12 mb-3">
      <div class="bg-white p-3 rounded shadow-sm card_metric h-100">
        <div class="heading_icon">
          <img
            src="../../../../../assets/images/clients_icon.svg"
            alt="clients"
          />
          <span>Merchants</span>
        </div>
        <div class="metric">
          <span>{{ totalMerchantCount }}</span>
        </div>
        <div class="small_metric"></div>
      </div>
    </div>

    <div class="col-lg-4 col-md-12 mb-3">
      <div class="bg-white p-3 rounded shadow-sm card_metric h-100">
        @if (userDetails.userRole === "ROLE_SUPER_ADMIN") {
          <div class="row h-100">
            <div class="col-7 d-flex flex-column last-card">
              <div class="heading_icon">
                <img
                  src="../../../../../assets/images/banks_icon.svg"
                  alt="banks"
                />
                <span>Clients</span>
              </div>
              <div class="metric">
                <span>{{ dashboardData?.totalClients }}</span>
              </div>
            </div>
            <div class="col-5 d-flex flex-column justify-content-between">
              <div>
                <div class="banks">
                  @for (
                    client of totalDevicesPerClient.slice(0, 3);
                    track $index
                  ) {
                    <ul>
                      <li class="bank_figure">
                        {{ client.value }} {{ client?.name }}
                      </li>
                    </ul>
                  }
                </div>
                <div class="view-banks" (click)="goToViewClients()">
                  <span
                    >View all Clients <i class="fa fa-arrow-right"></i
                  ></span>
                </div>
              </div>
            </div>
          </div>
        }

        @if (userDetails.userRole !== "ROLE_SUPER_ADMIN") {
          <div class="row h-100">
            <div class="col-7 d-flex flex-column last-card">
              <div class="heading_icon">
                <img
                  src="../../../../../assets/images/banks_icon.svg"
                  alt="banks"
                />
                <span>Apps</span>
              </div>
              <div class="metric">
                <span>{{ totalAppCount }}</span>
              </div>
            </div>
            <div class="col-5 d-flex flex-column justify-content-between">
              <div>
                <div class="banks">
                  @for (app of allApps.slice(0, 3); track $index) {
                    <ul class="banks">
                      <li class="bank_name">
                        {{ app?.appName | slice: 0 : 8 }}
                      </li>
                    </ul>
                  }
                </div>
                <div class="view-banks" (click)="goToViewApps()">
                  <span>View all Apps <i class="fa fa-arrow-right"></i></span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="row px-3">
    <div class="col-lg-12 col-md-12 mb-3">
      <div
        class="package_section wrap animated fadeIn dashboard_Chart-container"
      >
        <div class="chart_headers">
          <div class="chart_header-text">Devices</div>
        </div>
        <div class="chart-shell">
          @if (isDevicesChartLoading) {
            <div class="chart-state chart-loading">
              <div class="spinner-border text-danger" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          } @else if (isDevicesChartEmpty) {
            <div class="chart-state chart-no-data">
              <span>No data available</span>
            </div>
          } @else {
            <div id="boundTerminalChartDiv" class="chart-canvas"></div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="row px-3">
    <div class="col-lg-7 col-md-12 mb-3">
      <div
        class="package_section wrap animated fadeIn dashboard_Chart-container"
      >
        <div class="chart_headers">
          <div class="chart_header-text">Terminal Statistics</div>
          <div class="chart_header-dropdown">
            <label for="filter"
              >filter by:
              <select name="filter" id="filter" (change)="onDaysChange($event)">
                <option value="7">7 days</option>
                <option value="14">14 days</option>
                <option value="30">30 days</option>
              </select>
            </label>
          </div>
        </div>
        <div class="chart-shell">
          @if (isTerminalStatLoading) {
            <div class="chart-state chart-loading">
              <div class="spinner-border text-danger" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          } @else if (isTerminalChartEmpty) {
            <div class="chart-state chart-no-data">
              <span>No data available</span>
            </div>
          } @else {
            <div id="terminalStatisticsDiv" class="chart-canvas"></div>
          }
        </div>
      </div>
    </div>
    <div class="col-lg-5 col-md-12 mb-3">
      <div
        class="package_section wrap animated fadeIn dashboard_Chart-container dashboard_table-container"
      >
        <div class="chart_headers">
          <div class="chart_header-text">Application Versions</div>
        </div>
        <div
          class="custom-table animated fadeIn"
          style="height: 100%; width: 90%"
        >
          <div class="">
            <div class="card-body">
              <table class="table table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">App Name</th>
                    <th scope="col">No Of Devices</th>
                    <th scope="col">Version</th>
                  </tr>
                </thead>
                <tbody class="animated fadeIn">
                  @if (allAppUsage && allAppUsage.length > 0) {
                    @for (app of allAppUsage; track $index) {
                      <tr>
                        <td scope="row">{{ app.appName }}</td>
                        <td scope="row">{{ app.numberOfDevices }}</td>
                        <td>{{ app.appVersion }}</td>
                      </tr>
                    }
                  } @else {
                    <tr>
                      <td colspan="3" class="text-center py-4 text-muted">
                        No data available
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
